import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            marginBottom: theme.spacing(2),
        },
        date: {
            color: theme.palette.grey[900],
            fontSize: theme.typography.body2.fontSize,
            fontWeight: 'bold',
            marginBottom: theme.spacing(2),
        },
    });
});
export default (function (_a) {
    var date = _a.date, children = _a.children;
    var styles = useStyles({});
    return (React.createElement(Box, null,
        React.createElement(Typography, { className: styles.date }, moment(date).format('dddd DD MMMM')),
        React.createElement(Box, { className: styles.container }, children)));
});
//# sourceMappingURL=index.js.map